import useTranslate from "../../../modules/local/useTranslate";
import {Avatar, Button, Space} from "antd";
import classNames from "classnames";
import {renderIf} from "../../Shared";
import Toggle from "../../../components/Toggle";
import React from "react";
import {BsCaretDownFill, BsCaretRightFill} from "react-icons/bs";

export const WrapperFilterItem = ({showPrefix = true, className = "", label, children}) => {
    const t = useTranslate()
    return (
        <Space.Compact
            style={{display: 'inline-flex', alignItems: 'center', rowGap: 0}}
            className={classNames("custom-input-group", className)}>
            {renderIf(
                showPrefix,
                <Button disabled className="btn-input-group">
                    <span className="text-xs md:text-sm italic whitespace-no-wrap">
                      {t(label)}
                    </span>
                </Button>
            )}
            {children}
        </Space.Compact>
    )
}

export const FilterItem = ({ defaultValue = null, title, children }) => {
    const t = useTranslate()

    return (
        <Toggle defaultValue={defaultValue}>
            {(isToggle, toggle) => (
                <div className="flex flex-col gap-2">
                    <div className="flex items-center gap-2">
                        <Avatar
                            size={22}
                            className="flex flex-center bg-blue-100 rounded-md cursor-pointer"
                            icon={isToggle ? <BsCaretDownFill size={12} className="text-blue-600"/> :
                                <BsCaretRightFill size={12} className="text-blue-600"/>}
                            onClick={() => toggle()}
                        />
                        <span
                            onClick={() => toggle()}
                            className={classNames(
                                "font-medium text-sm hover:text-blue-700 cursor-pointer",
                                isToggle ? 'text-blue-500' : 'text-color-200')}>
                            {title}
                        </span>
                    </div>
                    {renderIf(
                        isToggle,
                        children
                    )}
                </div>
            )}
        </Toggle>
    )
}